import { z } from 'zod'
import { RecommendationSchema } from '../recommendation.js'

export const RecommendationsResponseSchema = z.array(RecommendationSchema)
export type RecommendationsResponse = z.infer<typeof RecommendationsResponseSchema>
